import css from 'styled-jsx/css';

const styles = css.global`#partiu-gp-numeros-da-sorte {
  padding: 16px 0 40px;
  background: #f0f0f0;
}

#partiu-gp-numeros-da-sorte .inner {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#partiu-gp-numeros-da-sorte .titulo {
  margin: 0 0 8px;
  color: #222;
  font-family: 'SantanderHeadline';
  font-size: 26px;
  font-weight: 800;
  line-height: 30px;
}

#partiu-gp-numeros-da-sorte .texto {
  margin: 0 0 20px;
  color: #444;
  font-family: 'SantanderMicroText';
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

#partiu-gp-numeros-da-sorte .cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  height: 48px;
  padding: 0 32px;
  border-radius: 999px;
  background: #ec0000;
  color: #fff;
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  pointer-events: none;
  background-color: #ccc;
}

#partiu-gp-numeros-da-sorte .imagem {
  display: block;
  width: 100%;
  aspect-ratio: 328 / 220;
  object-fit: cover;
  border-radius: 16px;
}

@media (min-width: 992px) {
  #partiu-gp-numeros-da-sorte {
    padding: 56px 0;
  }

  #partiu-gp-numeros-da-sorte .inner {
    flex-direction: row;
    align-items: flex-start;
    gap: 40px;
  }

  #partiu-gp-numeros-da-sorte .content {
    flex: 1;
  }

  #partiu-gp-numeros-da-sorte .titulo {
    font-size: 32px;
    line-height: 38px;
  }

  #partiu-gp-numeros-da-sorte .texto {
        margin: 0 0 50px;
    font-size: 18px;
    line-height: 26px;
    max-width: 480px;
  }

  #partiu-gp-numeros-da-sorte .imagem {
    flex: 0 0 448px;
    width: 448px;
    aspect-ratio: 320 / 227;
  }
}
`;

export default styles;